
<div *ngIf="show" class="modal loading-overlay" tabindex="-1">
    <div class="w-50 d-flex justify-content-center align-items-center">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modalComponentLabel">Uma Exceção foi Encontrada</h5>
          <button type="button" id="close-modal" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="close()"></button>
        </div>
        <div class="modal-body p-2 d-flex justify-content-center align-items-center">
            <textarea class="form-control" rows="5" readonly>
                {{message}}
            </textarea>
        </div>
        <div class="modal-footer"> 
            <button class="btn btn-primary" (click)="close()">Fechar</button>
        </div>
      </div>
    </div>
  </div>
